export default __webpack_public_path__ + "static/media/gerpal2.fc7d05f6.jpg";